/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.website.interactive.rpc.WebsiteInteractiveStoresService
 */

export const getEcommerceStoresRpc = {
  serviceName: 'com.hubspot.website.interactive.rpc.WebsiteInteractiveStoresService',
  rpcName: 'getEcommerceStores',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABeybygZVcGztGPQtm1BQHQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};